import React, { Component } from 'react';
import Swal from "sweetalert2/dist/sweetalert2.js";
import RkHeader from '../../../GeneralComponents/RkHeader'
import FormCreate from './FormCreate'
import ModalDocuments from './ModalDocuments'
import Loading from '../../../GeneralComponents/LoadingComponen'
import RiskPagination from '../../risk/RiskPagination';
import { isMobile } from 'react-device-detect';
import IndexMovil from "./Mobile/Index";

class Table extends Component {
    constructor(props) {
        super(props)
        this.token = document.querySelector("[name='csrf-token']").content;
        this.state = {
            showFilter: false,
            modal: false,
            ErrorValues: true,
            modeEdit: false,
            isLoaded: false,
            id: "",

            form: {
                name: "",
                description: "",
                proceso_type: "",
                prefix: "",
            },

            // Proceso cuyo modal de documentos esta abierto (null = cerrado)
            procesoDocuments: null,
        }
    }

    messageSuccess = (response) => {
        Swal.fire({
            position: "center",
            type: `${response.type}`,
            title: `${response.success}`,
            showConfirmButton: false,
            timer: 1500,
        });
    };

    clearValues = () => {
        this.setState({
            modeEdit: false,
            id: "",
            form: {
                name: "",
                description: "",
                proceso_type: "",
                prefix: "",
            }
        })
    }

    validationForm = () => {
        if (this.state.form.name != "" &&
            this.state.form.proceso_type != "" &&
            this.state.form.prefix != ""
        ) {
            this.setState({ ErrorValues: true })
            return true
        } else {
            this.setState({ ErrorValues: false })
            return false
        }
    }

    HandleChange = (e) => {
        this.setState({
            form: {
                ...this.state.form,
                [e.target.name]: e.target.value
            }
        });
    }

    toogle = (from) => {
        if (from == "new") {
            this.setState({ modal: true })
            this.clearValues();
        } else {
            this.setState({ modal: false, ErrorValues: true })
        }
    }

    HandleClick = () => {
        if (this.validationForm() == true) {
            this.setState({ isLoaded: true })
            const url = this.state.modeEdit ? `/settings/procesos/${this.state.id}` : "/settings/procesos";

            fetch(url, {
                method: this.state.modeEdit ? 'PATCH' : 'POST',
                body: JSON.stringify(this.state.form),
                headers: {
                    "X-CSRF-Token": this.token,
                    "Content-Type": "application/json"
                }
            })
                .then(res => res.json())
                .catch(error => console.error("Error:", error))
                .then(data => {
                    this.clearValues();
                    this.setState({ modal: false, isLoaded: false })
                    if (!data) return;
                    if (data.type != "error") this.props.loadData();
                    this.messageSuccess(data);
                });
        }
    }

    delete = id => {
        Swal.fire({
            title: "¿Estás seguro?",
            text: "¡El registro será eliminado para siempre!",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#009688",
            cancelButtonColor: "#d33",
            confirmButtonText: "Eliminar",
            cancelButtonText: "Cancelar"
        }).then(result => {
            if (result.value) {
                fetch(`/settings/procesos/${id}`, {
                    method: "delete",
                    headers: {
                        "X-CSRF-Token": this.token,
                        "Content-Type": "application/json"
                    }
                })
                    .then(response => response.json())
                    .then(response => {
                        if (response.type != "error") this.props.loadData()
                        this.messageSuccess(response)
                    });
            }
        });
    };

    edit = (proceso) => {
        this.setState({
            id: proceso.id,
            modal: true,
            modeEdit: true,
            form: {
                name: proceso.name,
                description: proceso.description,
                proceso_type: proceso.proceso_type,
                prefix: proceso.prefix,
            }
        })
    }

    //documents

    openDocuments = (proceso) => {
        this.setState({ procesoDocuments: proceso })
    }

    closeDocuments = () => {
        this.setState({ procesoDocuments: null })
    }

    showFilter = () => {
        this.setState({ showFilter: true })
    }

    cancelFilter = () => {
        // clearValues del padre limpia el filtro y recarga la lista.
        this.props.clearValues();
        this.setState({ showFilter: false })
    }

    handleKeyFilter = (e) => {
        if (e.key === "Enter") this.props.handleClickFilter();
    }

    render() {
        const { estados, data } = this.props;
        const showActions = estados.editar || estados.eliminar;

        return (
            <React.Fragment>
                <RkHeader
                    title={"Procesos"}
                    subtitle={"Gestión de procesos"}
                    icon="fas fa-project-diagram"
                    titleNew={"Nuevo proceso"}
                    titleFilter={"Filtros"}
                    onClickNew={this.toogle}
                    showNew={estados.crear}
                    onClickFilter={this.showFilter}
                    showFilter={true}

                    //favorite module params
                    is_index={true}
                    url={this.props.current_url}
                />

                {this.state.procesoDocuments && (
                    <ModalDocuments
                        backdrop={"static"}
                        modal={true}
                        toggle={this.closeDocuments}
                        proceso={this.state.procesoDocuments}
                        canManage={estados.gestionarDocumentos}
                        onChange={this.props.loadData}
                    />
                )}

                {this.state.modal && (
                    <FormCreate
                        //modal props
                        backdrop={"static"}
                        modal={this.state.modal}
                        toggle={this.toogle}
                        title={this.state.modeEdit ? "Actualizar proceso" : "Nuevo proceso"}
                        nameSubmit={this.state.modeEdit ? "Actualizar" : "Crear"}

                        //form props
                        formValues={this.state.form}
                        errorValues={this.state.ErrorValues}
                        onChangeForm={this.HandleChange}
                        submitForm={this.HandleClick}
                        tenant={this.props.tenant}
                        isLoaded={this.state.isLoaded}
                    />
                )}

                {!this.props.isLoaded ? (
                    <div className="rk-wrap">
                        {this.state.showFilter && (
                            <div className="rk-filter">
                                <div className="rk-filter__head">
                                    <i className="fas fa-filter"></i> Filtrar procesos
                                </div>

                                <div className="rk-filter__grid">
                                    <div className="rk-field rk-filter__wide">
                                        <label className="rk-label">Nombre</label>
                                        <input
                                            type="text"
                                            name="name"
                                            className="rk-input"
                                            placeholder="Nombre del proceso"
                                            value={this.props.formFilter.name}
                                            onChange={this.props.handleChangeFilter}
                                            onKeyDown={this.handleKeyFilter}
                                        />
                                    </div>
                                </div>

                                <div className="rk-filter__actions">
                                    <button type="button" className="rk-btn rk-btn--ghost" onClick={this.cancelFilter}>
                                        Cerrar
                                    </button>
                                    <button type="button" className="rk-btn rk-btn--primary" onClick={() => this.props.handleClickFilter()}>
                                        <i className="fas fa-filter"></i> Aplicar filtro
                                    </button>
                                </div>
                            </div>
                        )}

                        {!isMobile ? (
                            <div className="rk-table-card">
                                <div className="rk-table-scroll">
                                    {data.length >= 1 ? (
                                        <table className="rk-table">
                                            <thead>
                                                <tr>
                                                    <th style={{ width: 100 }}>Prefijo</th>
                                                    <th>Proceso</th>
                                                    <th>Tipo</th>
                                                    <th>Descripción</th>
                                                    <th style={{ width: 170 }}>Documentos</th>
                                                    {showActions && <th className="rk-table__actions" style={{ width: 96 }}></th>}
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {data.map(proceso => {
                                                    const documents = (proceso.general_files || []).length;

                                                    return (
                                                        <tr key={proceso.id}>
                                                            <td><span className="rk-chip">{proceso.prefix}</span></td>
                                                            <td className="rk-cell-primary">{proceso.name}</td>
                                                            <td className="rk-cell-muted">{proceso.proceso_type}</td>
                                                            <td className="rk-table__desc">{proceso.description ? proceso.description : "—"}</td>
                                                            <td>
                                                                <button type="button" className="rk-link-btn" onClick={() => this.openDocuments(proceso)}>
                                                                    <i className="fas fa-folder-open"></i> Documentos
                                                                    <span className={`rk-count ${documents == 0 ? "rk-count--zero" : ""}`}>{documents}</span>
                                                                </button>
                                                            </td>
                                                            {showActions && (
                                                                <td className="rk-table__actions">
                                                                    <span className="rk-inline-actions">
                                                                        {estados.editar && (
                                                                            <button type="button" className="rk-icon-btn" onClick={() => this.edit(proceso)} title="Editar">
                                                                                <i className="fas fa-pencil-alt"></i>
                                                                            </button>
                                                                        )}
                                                                        {estados.eliminar && (
                                                                            <button type="button" className="rk-icon-btn rk-icon-btn--cancel" onClick={() => this.delete(proceso.id)} title="Eliminar">
                                                                                <i className="fas fa-trash-alt"></i>
                                                                            </button>
                                                                        )}
                                                                    </span>
                                                                </td>
                                                            )}
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    ) : (
                                        <div className="rk-empty">
                                            <i className="fas fa-project-diagram"></i>
                                            <p>{this.props.showbtnSubmit ? "Ningún proceso coincide con el filtro" : "Todavía no hay procesos creados"}</p>
                                            {(estados.crear && !this.props.showbtnSubmit) && (
                                                <button type="button" className="rk-btn rk-btn--primary" style={{ marginTop: 16 }} onClick={() => this.toogle('new')}>
                                                    <i className="fas fa-plus"></i> Nuevo proceso
                                                </button>
                                            )}
                                        </div>
                                    )}
                                </div>

                                <RiskPagination
                                    page={this.props.activePage}
                                    perPage={this.props.countPage}
                                    total={this.props.totalData}
                                    onPage={this.props.handlePageChange}
                                    showPerPage={false}
                                />
                            </div>
                        ) : (
                            <React.Fragment>
                                <IndexMovil
                                    data={data}
                                    estados={estados}
                                    edit={this.edit}
                                    delete={this.delete}
                                    openDocuments={this.openDocuments}
                                />

                                <div className="rk-table-card">
                                    <RiskPagination
                                        page={this.props.activePage}
                                        perPage={this.props.countPage}
                                        total={this.props.totalData}
                                        onPage={this.props.handlePageChange}
                                        showPerPage={false}
                                    />
                                </div>
                            </React.Fragment>
                        )}
                    </div>
                ) : (
                    <Loading />
                )}
            </React.Fragment>
        );
    }
}

export default Table;
